import React from 'react';
import PropTypes from 'prop-types';

import { Col, Spinner } from 'reactstrap';
import { t } from '../../common/Translate';

export const FolderSection = ({
  title = '',
  showArrow = false,
  showVehInfos = false,
  children = false,
  action = () => {},
  isLoading = false,
  dataTestid = '',
}) => {
  let content = null;
  if (isLoading) content = <Spinner type="grow" />;
  else if (!children) content = <div className="calendar-meeting-folder-section-no-value">{t('no_data_yet')}</div>;
  else content = children;

  return (
    <Col xs="12" lg="4" className="calendar-meeting-folder-section-col">
      <div
        className={`calendar-meeting-folder-section ${showArrow ? 'arrow-chevron ' : ''}${
          !children || !showArrow ? '' : 'active'
        }`}
        onClick={action}
        onKeyDown={() => {}}
        role="button"
        tabIndex={0}
        data-testid={dataTestid}
      >
        <div
          className={`calendar-meeting-folder-section-title ${!children || !showArrow ? '' : 'active'}${
            !showVehInfos ? '' : 'active'
          }`}
        >
          {title}
        </div>

        <div className="calendar-meeting-folder-section-body">{content}</div>
      </div>
    </Col>
  );
};

FolderSection.propTypes = {
  title: PropTypes.string,
  showArrow: PropTypes.bool,
  showVehInfos: PropTypes.bool,
  action: PropTypes.func,
  isLoading: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.bool, PropTypes.array, PropTypes.object]),
  dataTestid: PropTypes.string.isRequired,
};

FolderSection.defaultProps = {
  title: '',
  showArrow: false,
  showVehInfos: false,
  action: () => {},
  isLoading: false,
  children: false,
};
